import React from 'react';

const About = () => {
  return (
    <div className="about">
      <div className="container">
        <h1>About Kids Club Early Learning Center LLC</h1>
        
        <section className="mission">
          <h2>Our Mission</h2>
          <p>
            Kids Club Early Learning Center is a welcoming environment where children from six weeks to twelve years old can thrive. 
            Our dedicated team provides comprehensive programs, including Preschool and Afterschool programs. We are committed to 
            fostering a Love of learning and preparing children for future success through engaging age-appropriate activities. 
            Our center proudly accepts Hillsborough County School Readiness, Hillsborough V.P.K, Polk County School Readiness, 
            and Polk V.P.K ensuring every child has the opportunity to reach their full Potential.
          </p>
        </section>

        <section className="philosophy">
          <h2>Our Philosophy</h2>
          <p>
            We believe that every child is unique and deserves to be celebrated for their individual strengths and 
            abilities. Our approach combines structured learning with creative play, allowing children to explore, 
            discover, and grow at their own pace while building a strong foundation for future academic success.
          </p>
        </section>

        <section className="programs">
          <h2>Our Programs</h2>
          <div className="programs-grid">
            <div className="program">
              <h3>Infant Care (6 weeks - 12 months)</h3>
              <p>Loving, individualized care focusing on bonding, sensory development, and establishing routines.</p>
            </div>
            <div className="program">
              <h3>Toddler Program (1 - 2 years)</h3>
              <p>Encouraging exploration, language development, and social skills through guided play and activities.</p>
            </div>
            <div className="program">
              <h3>Preschool (3 - 4 years)</h3>
              <p>Structured learning activities that promote school readiness, creativity, and independence.</p>
            </div>
            <div className="program">
              <h3>Pre-Kindergarten (4 - 5 years)</h3>
              <p>Comprehensive preparation for kindergarten with focus on academic skills and social development.</p>
            </div>
          </div>
        </section>

        <section className="staff">
          <h2>Our Qualified Staff</h2>
          <p>
            Our experienced and caring educators are committed to providing the highest quality care and education. 
            All staff members undergo thorough background checks and participate in ongoing professional development 
            to ensure they stay current with best practices in early childhood education.
          </p>
        </section>

        <section className="facility">
          <h2>Our Facility</h2>
          <p>
            Located in the heart of Plant City, our modern facility features age-appropriate classrooms, secure 
            outdoor play areas, and specialized spaces for various activities. We maintain the highest standards 
            of cleanliness and safety to provide a healthy environment for all children.
          </p>
        </section>

        <section className="accreditation">
          <h2>Licensing & Accreditation</h2>
          <p>
            Kids Club Early Learning Center LLC is licensed by the Florida Department of Children and Families 
            and adheres to all state regulations for child care facilities. We are committed to maintaining 
            the highest standards of care and education.
          </p>
        </section>
      </div>
    </div>
  );
};

export default About;